import request from '../helpers/request';

const addRequestAttachment = async (requestId, file, errMsg) => {
  const formData = new FormData();

  formData.append('file', file);

  return await request.post(
    `/Request/add_file/${requestId}`,
    formData,
    errMsg || `При загрузке файлов произошла ошибка`
  );
};

export default addRequestAttachment;
